var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitScreenAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4523_9389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00390625,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4523_9389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.7539C3.3375 15.7539 2.98438 15.607 2.69063 15.3133C2.39688 15.0195 2.25 14.6664 2.25 14.2539V11.2539C2.25 10.8414 2.39688 10.4883 2.69063 10.1945C2.98438 9.90078 3.3375 9.75391 3.75 9.75391H14.25C14.6625 9.75391 15.0156 9.90078 15.3094 10.1945C15.6031 10.4883 15.75 10.8414 15.75 11.2539H3.75V14.2539H11.25V15.7539H3.75ZM3.75 8.25391C3.3375 8.25391 2.98438 8.10703 2.69063 7.81328C2.39688 7.51953 2.25 7.16641 2.25 6.75391V3.75391C2.25 3.34141 2.39688 2.98828 2.69063 2.69453C2.98438 2.40078 3.3375 2.25391 3.75 2.25391H14.25C14.6625 2.25391 15.0156 2.40078 15.3094 2.69453C15.6031 2.98828 15.75 3.34141 15.75 3.75391V6.75391C15.75 7.16641 15.6031 7.51953 15.3094 7.81328C15.0156 8.10703 14.6625 8.25391 14.25 8.25391H3.75ZM3.75 6.75391H14.25V3.75391H3.75V6.75391ZM14.25 17.2539V15.7539H12.75V14.2539H14.25V12.7539H15.75V14.2539H17.25V15.7539H15.75V17.2539H14.25Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitScreenAdd);
export default __webpack_public_path__ + "static/media/SplitScreenAdd.f5720207e086e9ba0ab03f6b781257a0.svg";
export { ForwardRef as ReactComponent };